import $ from 'jquery';
export default class Mask {
  static show() {
    Mask.hide();
    $('body').append('<div id="mask" class="modal-backdrop fade in"></div>');
  }

  static hide() {
    $('#mask').remove();
  }
}
